import {
  type Notification,
  NOTIFICATION_TYPE,
  type NotificationType,
} from 'src/data/notifications';

const CUSTOMER_NOTIFICATIONS: NotificationType[] = [
  NOTIFICATION_TYPE.growthCampaignDDFeatures,
  NOTIFICATION_TYPE.growthCampaignBonusWords,
  NOTIFICATION_TYPE.basicUsersAccessToDDFeatures,
  NOTIFICATION_TYPE.basicTieredAccessToDDFeatures,
];
export const areCustomerNotifications = (notifications: Notification[]) =>
  (notifications || []).some((n) => CUSTOMER_NOTIFICATIONS.includes(n?.type));
